<script>
    import _              from 'lodash'
    import { fade }       from 'svelte/transition'
    import { setContext } from 'svelte'
    import { createEventDispatcher } from 'svelte'
    import ConfirmAction from './ConfirmAction.svelte'
    
    export let item
    export let active        = null
    export let withHeader    = true
    export let edit          = true
    export let debug         = false
    export let disabled      = false
    export let loading       = false
    export let resetOnToggle = true
    export let action        = null
    export let actions       = []
    export let onUpdate      = () => Promise.resolve(true)
    export let onRemove      = () => Promise.resolve(true)
    export let isDirty       = () => false
    export let validateItem  = () => {}
    export let idOf          = i => i.id
    export let errorHandler  = defaultErrorHandler

    export let buttons = {
        add    : { label: 'Adicionar' , disabled: false },
        change : { label: 'Alterar'   , disabled: false },
        remove : { label: 'Remover'   , disabled: false }, 
        cancel : { label: 'Cancelar'  , disabled: false },
    }

    let copy      = clone(item)
    let execError = null
    let removing  = false
    let forceWait = false

    const dispatch = createEventDispatcher()

    setContext('item', {
        close: reset => toggleActive(reset)
    })

    function clone(item) {
        return _.cloneDeep(item)
    }

    function defaultErrorHandler(kind, obj /* item */, err /* the error */) {
        return {
            display : true,
            message : err 
        }
    }

    function update() {
        loading = true
        onUpdate(item).then(done => {
            copy      = clone(item)
            loading   = false
            active    = null
            primary   = false
            execError = null //done ? null : 'erro'
        })
        .catch(err => {
            loading   = false
            execError = errorHandler('update', item, err)
            if(execError.autoHide) {
                setTimeout(() => execError = null, 5000)
            }
        })        
    }

    function remove(force) {
        return () => {
            if(!force) {
                forceWait = true
                return
            }
            removing = true
            onRemove(copy).then(done => {
                removing  = false
                loading   = false
                active    = null
                execError = null //done ? null : 'erro'
            })
            .catch(err => {
                removing  = false
                loading   = false
                execError = errorHandler('remove', copy, err)
                if(execError.autoHide) {
                    setTimeout(() => execError = null, 5000)
                }
            })
        }
    }

    function toggleActive(reset) {
        if(active === idOf(copy)) {
            action    = null
            active    = null
            execError = null
            primary   = false
            secondary = false
            dispatch('cancel', { item })

            if(resetOnToggle && reset) {
                item = clone(copy)
            }
        } else {
            active = idOf(copy)
            const el = document.querySelector(`#item-${idOf(copy)} input`)
            if(el && edit) {
                el.focus()
                el.select()
            }
        }
    }

    function togglePrimary() {
        const keepOpen = secondary && selected
        //console.log(`primary:${primary}, secondary:${secondary}, selected:${selected}, keepopen:${keepOpen}`)
        secondary = false
        primary = !primary
        if(!keepOpen)
            toggleActive(true)
    }

    function toggleSecondary(it) {
        primary   = false
        const keepOpen = secondary && action && action.id !== it.id
        action    = it
        if(!keepOpen) {
            secondary = !secondary
            toggleActive(false)            
        }
        if(secondary) {
            loading = action.triggerLoading
            action.onClick().then(() => loading = false).catch(() => loading = false)
        }
    }

    function checkDirty(item, active) {
        return idOf(item) === active ? isDirty(item, copy) : false
    }

    let primary   = false
    let secondary = idOf(copy) === active

    $: selected      = idOf(copy) === active
    $: showPrimary   = selected && primary
    $: showSecondary = selected && secondary
    $: dirty         = checkDirty(item, active)
    $: formErrors    = validateItem(item)
    $: hasErrors     = formErrors && Object.keys(formErrors).length > 0
</script>

<style>
    .head {
        font-size: 16pt;
    }

    .entry.active {
        border: 0 !important;
    }

    .entry.deleted {
        border: 1px solid red;
        opacity: 0;
        height: 0px;
        display: none;
    }

    .entry {
        margin: 0;
        transition: all .7s cubic-bezier(0, 1, 0.5, 1);
    }

    .entry.active {
        padding: 2em;
    }

    .entry.active:not(:first-child):not(:last-child) {
        margin: 6px 0 !important;
    }

    .entry.active:first-child {
        margin-bottom: 6px !important;
    }

    .entry.active:last-child {
        margin-top: 6px !important;
    }

    .entry .head {
        display: flex;
    }

    .entry .head {
        flex: 1;
    }

    .form {
        transition: all .7s cubic-bezier(0, 1, 0.5, 1);
    }

    .form.notHidden {
        max-height: 5000px;
        overflow-y: auto;
        opacity: 1;
        /* display: block; */
    }

    .form.hidden {
        opacity: 0;
        max-height: 0px;
        overflow: hidden;
    }

    .form .item {
        margin: 1em 0;
    }

    .actions {
        display: flex;
        align-items: flex-end;
    }

    .actions .red.label:first-child {
        margin-right: 2em;
    }

    .debug {
        font-size: 8pt;
        color: #ccc;
    }

    .debug .red + pre {
        color: red;
    }

    button.action {
        position: relative;
    }
    .issue {
        display      : grid;
        place-items  : center;
        position     : absolute;
        top          : -11px;
        right        : -11px;
        background   : var(--color-red);
        color        : white;
        z-index      : 999;
    }
    .issue /* from semantic */ {
        text-decoration: none;
        display: inline-block;
        vertical-align: baseline;
        margin: 0 .14285714em;
        text-transform: none;
        font-weight: 700;
        border: 0 solid transparent;
        font-size: .85714286rem;
        cursor: pointer;
        min-width: 2em;
        min-height: 2em;
        border-radius: 500rem;
        padding: .5em!important;
        line-height: 1em;
        text-align: center;
    }
</style>

<div id="item-{idOf(copy)}" class="ui segment entry {selected ? 'active' : ''}">
    {#if loading}
        <div class="ui active dimmer">
            <div class="ui loader"></div>
        </div>
    {/if}
    {#if debug}
        <div class="debug ui horizontal segments">
            <div class="ui segment">
                <span class="ui grey ribbon label">Summary</span>
                <div class="ui list">
                    <div class="item">item: {idOf(item)}</div>
                    <div class="item">dirty : {dirty}</div>
                    <div class="item">active: {active}</div>
                    <div class="item">primary: {primary}</div>
                    <div class="item">secondary: {secondary}</div>
                    <div class="item">selected: {selected}</div>
                    <div class="item">action: {action ? action.id : null}</div>
                </div>
            </div>
            <div class="copy ui segment">
                <span class="ui grey ribbon label">Copy</span>
                <pre>{JSON.stringify(copy, undefined, 2)}</pre>
            </div>
            <div class="item ui segment">
                <span class="ui ribbon label" class:grey={!dirty} class:red={dirty}>Item</span>
                <pre>{JSON.stringify(item, undefined, 2)}</pre>
            </div>
            <div class="item ui segment">
                <span class="ui ribbon label" class:grey={!dirty} class:red={hasErrors}>Errors</span>
                <pre>{JSON.stringify(formErrors, undefined, 2)}</pre>
            </div>
        </div>    
    {/if}
    <div class="head">
        {#if withHeader}
            <slot name="header"></slot>
        {/if}
        <div class="actions">
            {#if execError && execError.display}
                <div transition:fade class="ui small red label">{execError.message}</div>
            {:else}
                {#each actions as a}
                    <button class="ui basic action button" class:disabled={a.disabled} on:click={e => toggleSecondary(a)}>
                        {#if a.issues && a.issues.length > 0} 
                            <span class="issue">{a.issues.length}</span>
                        {/if}
                        {a.name}
                    </button>
                {/each}
            {/if}
            {#if edit}
                {#if idOf(copy) > 0}
                    <button class:disabled={disabled || secondary || selected} class:loading={removing} class="ui icon button" on:click={remove(false)}>
                        {buttons.remove.label}
                    </button>
                {/if}
            {/if}
            <button class:disabled={disabled || secondary} class="ui primary icon button" on:click={togglePrimary}>
                {#if idOf(copy) === 0} {#if primary} {buttons.cancel.label} {:else} {buttons.add.label} {/if}
                {:else if selected} {buttons.cancel.label}
                {:else}             {buttons.change.label}
                {/if}
            </button>
        </div>
    </div>
    <div class="form" class:notHidden={showPrimary} class:hidden={!showPrimary}>
        <slot name="primary" display={showPrimary} errors={formErrors}></slot>
        {#if edit}
            <div class="item">
                <button class="ui primary button" on:click={update} disabled={!dirty || hasErrors}>Salvar</button>
                <!-- {JSON.stringify(formErrors)} -->
                {#if /* dirty && */ execError && execError.display}
                    <div transition:fade class="ui small red label">{execError.message}</div>
                {/if}
            </div>
        {/if}
    </div>
    <div class="form .secondary" class:notHidden={showSecondary} class:hidden={!showSecondary}>
        <slot name="secondary" {action} display={showSecondary} error={execError}></slot>
    </div>
</div>
<ConfirmAction bind:active={forceWait} confirm={remove(true)}></ConfirmAction>

